import { coverSheetService } from '@/services'

let initialState = {
  coverSheetTemplates: [],
  mergedCoverSheets: []
}

export default {
  state: () => initialState,
  mutations: {
    SET_COVER_SHEET_TEMPLATES(state, list) {
      state.coverSheetTemplates = list
    },
    RESET_COVERSHEETS(state) {
      // eslint-disable-next-line no-unused-vars
      state = initialState
    },
    TRUNCATE_MERGED_COVERSHEETS(state) {
      state.mergedCoverSheets = initialState.mergedCoverSheets
    },
    ADD_MERGED_COVERSHEETS(state, coverSheet) {
        state.mergedCoverSheets.push(coverSheet)
    }
  },
  actions: {
    async fetchCoverSheetTemplates({ commit }) {
      return await coverSheetService
        .getCoverSheets()
        .then((response) => {
          return response && commit('SET_COVER_SHEET_TEMPLATES', response)
        })
        .catch((error) => {
          console.error('Error in coverSheet/getAll:', error)
        })
    },
    resetCoverSheets({ commit }) {
      commit('RESET_COVERSHEETS')
    }
  },
  getters: {
    mergedCoverSheets: (state) => {
      if(state.mergedCoverSheets.length >= 0) {
        return state.mergedCoverSheets
      }
    },
  }
}
